import { render, staticRenderFns } from "./KinostartToolbar.vue?vue&type=template&id=0317d02a&"
import script from "./KinostartToolbar.vue?vue&type=script&lang=js&"
export * from "./KinostartToolbar.vue?vue&type=script&lang=js&"
import style0 from "./KinostartToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports